export const PURCHASE_PRODUCT = 'PURCHASE_PRODUCT';
export const STAR_PRODUCT = 'STAR_PRODUCT';

export const PAGE_VIEW = 'PAGE_VIEW';
export const PROMOTION_CLICK = 'PROMOTION_CLICK';
export const PROMOTION_CLOSE = 'PROMOTION_CLOSE';

export const PRODUCT_CLICK = 'PRODUCT_CLICK';